import { render, staticRenderFns } from "./WsSpacer.vue?vue&type=template&id=8a9bd352&"
import script from "./WsSpacer.vue?vue&type=script&lang=js&"
export * from "./WsSpacer.vue?vue&type=script&lang=js&"
import style0 from "./WsSpacer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports